import React, { useRef } from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import { IconSize } from '../../Icons/IconWrap';
import CloseBold from '../../Icons/CloseBold';
import noop from '../../utils/noop';
import { setRefs } from '../../utils/refHelpers';
import { useOnOutsideClick } from '../../utils/hooks/useOnOutsideClick';
import s from './BasicTooltip.scss';
var BasicTooltip = React.forwardRef(function (_a, innerRef) {
    var className = _a.className, withCloseButton = _a.withCloseButton, placement = _a.placement, children = _a.children, _b = _a.secondaryPlacement, secondaryPlacement = _b === void 0 ? 'middle' : _b, _c = _a.onClose, onClose = _c === void 0 ? noop : _c;
    var rootRef = useRef(null);
    useOnOutsideClick(rootRef, onClose, onClose !== noop);
    return (React.createElement("div", { className: classnames(s['root'], s["placement-" + placement], s["placement-" + secondaryPlacement], className), ref: function (node) {
            setRefs([innerRef, rootRef], node);
        } },
        children,
        React.createElement("div", { className: s['tooltip-arrow'] }),
        withCloseButton && (React.createElement(PlainButtonOrLink, { className: s['close'], onClick: onClose },
            React.createElement(CloseBold, { size: IconSize.SMALLER, disableDefaultColors: true })))));
});
BasicTooltip.displayName = 'BasicTooltip';
export default BasicTooltip;
//# sourceMappingURL=BasicTooltip.js.map